






































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Ththreshold from "../../../store/entities/ththreshold";
@Component
export default class CreateThthreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  ththreshold: Ththreshold = new Ththreshold();
  idisable:boolean = false;
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  save() {
    (this.$refs.ththresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "ththreshold/create",
          data:this.ththreshold
        });
        (this.$refs.ththresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel(){
            (this.$refs.ththresholdForm as any).resetFields();
            this.$emit('input',false);
        }
  ththresholdRule = {
    tName: [{ required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    maxTemp: [{required: true, message: "请填写最大温度",type:"number", trigger: "blur" }],
    minTemp: [{required: true, message: "请填写最大温度",type:"number", trigger: "blur" }],
    maxHumi: [{required: true, message: "请填写最大湿度",type:"number", trigger: "blur" }],
    minHumi: [{required: true, message: "请填写最小湿度",type:"number", trigger: "blur" }],
  };
}
